import Link from "next/link"


function SocialLink({ link, icon: Icon, labelName= "" }) {
  return (
    link ? (
        <Link href={link} passHref
        aria-label={labelName}
        >
          <div className="bg-white text-primary text-lg lg:size-10 p-2 flex justify-center items-center rounded-full hover:scale-125">
            <Icon className="lg:size-7" />
          </div>
        </Link>
      ) : null
  )
}

export default SocialLink